import apiClient from '../client/api';

export enum NotificationType {
  RiskAssessment = 'riskAssessment',
  ScreeningFollowUp = 'screeningFollowUp',
}

export type RiskAssessmentNotification = {
  version: string;
};

export type FollowUpNotification = {
  actions: string;
  descriptions: Array<string>;
  question: string;
};

export type Notification = {
  id: string;
  type: NotificationType;
  dismissedAt: Date | null;
  details: RiskAssessmentNotification | FollowUpNotification;
};

async function dismissNotification(notificationId: string) {
  const res = await apiClient.put(`/notification/${notificationId}`);
  return res.data;
}

async function getNotificationByType(type: NotificationType): Promise<Notification> {
  const res = await apiClient.get(`/notification/${type}`);
  return res.data;
}

export default { dismissNotification, getNotificationByType };
